<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Mike Thomas-Hall grew up in Wales in the Rhondda Valley, but he never met Rhondda. Just as well because in Sydney, Australia, he met Belinda and she was an answer to a prayer. Four sons and 50 years later, they are still very grateful for each other. They live in the lush hills of the Tweed Valley in New South Wales, and you are very welcome to drop in.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?317a0b0a